export default __webpack_public_path__ + "static/media/CONVESANDO_MINI.084a181b.jpg";